import templateUrl from "emun.auth/verify-email.htm";
import controller from "emun.auth/verify-email.controller";

export default {
  controller,
  templateUrl,
	bindings: {
		registrationUrl: "@",
		loginUrl: "@"
	}
};
